import { Select as CapsuleSelect } from '@truepill/react-capsule'
import Select from 'components/Select'
import { InsurancePlanTypeV2 } from 'types'

type PlanTypeSelectProps = {
  value?: string
  onChange: (value: string) => void
  withCapsule?: boolean
}

const planTypeOptions = Object.values(InsurancePlanTypeV2).map(value => ({
  label: value,
  value: value,
}))

const defaultPlanTypeOption = InsurancePlanTypeV2.NotSpecified

const PlanTypeSelect = ({ value, onChange, withCapsule = false }: PlanTypeSelectProps): JSX.Element => {
  const currentValue = value || defaultPlanTypeOption
  const selectedValue = { label: currentValue, value: currentValue }

  if (withCapsule) {
    return (
      <CapsuleSelect
        data-testid="plan-type"
        selectedKey="label"
        optionComponent={({ option }) => <div>{option.label}</div>}
        options={planTypeOptions}
        label=""
        required
        placeholder=""
        onChange={option => {
          const newValue = option ? option.value : defaultPlanTypeOption
          onChange(newValue)
        }}
        value={
          currentValue
            ? { label: currentValue, value: currentValue }
            : { label: defaultPlanTypeOption, value: defaultPlanTypeOption }
        }
        css={{
          width: '100%',
          margin: '12px 0 0 0',
        }}
        variant="small"
      />
    )
  }

  return (
    <Select
      data-testid="plan-type"
      disableClear={true}
      multiple={false}
      placeholder="Plan Type"
      options={planTypeOptions}
      value={selectedValue}
      onChange={([option]) => {
        const newValue = option ? option.value : defaultPlanTypeOption
        onChange(newValue)
      }}
    />
  )
}

export default PlanTypeSelect
